import React from 'react'
import { AuthForm } from './modules/AuthForm'
import { ReactComponent as BackgroundLogo } from '../../assets/img/logo_background.svg'
import './AuthPage.sass'

export const AuthPage = () => {
  return (
    <div className='auth-page'>
      <AuthForm />
    </div>
  )
}
